import { Link } from "react-router-dom";
import { cn } from "../utils";

interface IMenuNavMobileProps {
  switchEffect: (value: "inicio" | "nosotros" | "servicios" | "contacto") => boolean
  onClose: (e?: React.MouseEvent<HTMLOrSVGElement>) => void
}

const MenuNavMobile: React.FC<IMenuNavMobileProps> = ({ switchEffect, onClose }) => {

  return (
    <div id="menu-nav-on-mobile" className="modal-enter-left overflow-x-hidden absolute left-0 h-full w-[300px] bg-white text-primary-dark flex flex-col pt-2 text-base gap-4 px-4 font-tommy-regular">
      <Link to="/" onClick={() => onClose()} className={cn("hover:text-primary transition-all duration-500", switchEffect("inicio") && "text-primary")}>Inicio</Link>
      <a href="#nosotros" onClick={() => onClose()} className={cn("hover:text-primary transition-all duration-500", switchEffect("nosotros") && "text-primary")}>Nosotros</a>
    </div>
  );
}

export default MenuNavMobile;